import React, {Component} from "react";
import {connect} from 'react-redux';
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJStockVideoHeaderViewContainer from "./FJStockVideoHeaderViewContainer";
import FJVideoMediasContainer from "./FJVideoMediasContainer";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJPhotoMediasContainer from "./FJPhotoMediasContainer";
import FJMusicMediasContainer from "./FJMusicMediasContainer";
import FJStockTipsView from "../view/stockVideo/FJStockTipsView";
import FJLocalStore from "../../../store/FJLocalStore";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJLazy from "../../../common/component/FJLazy";
import FJStockBox from "../view/FJStockBox";

class FJStockVideoModalContainer extends Component{

  constructor(props) {
		super(props);
		this.state = {
			tips: [],
      modalShown: false,
		}
	}

  componentDidMount() {
    window.FJEvent.subscribe(FJEventConstant.SHOW_STOCK_TIP, this._addTips);
  }

	_addTips = (preSelected) => {
		this._tipId = !this._tipId ? 1 : this._tipId + 1;
		let curId = this._tipId;
		let curTips = this.state.tips;
		this.setState({
			tips: [...curTips, {
				id: curId,
				type: preSelected ? 'remove' : 'add',
				active: false
			}],
		}, () => {
			let curTips = this.state.tips;
			let tip = curTips.find(tip => tip.id === curId);
			if (tip) {
				tip.active = true;
				this.setState({tips: curTips}, () => {
					setTimeout(() => {
						let curTips = this.state.tips;
						if (curTips && curTips.length >= 1) {
							if (curTips[0].id === curId) {
								this.setState({
									tips: curTips.splice(1),
								})
							}
						}
					}, 3000);
				});
			}
		});
	}

	_onShown = () => {this.setState({modalShown: true})};
  _onHidden = () => {this.setState({modalShown: true}, () => {
    window.FJEvent.dispatch(FJEventConstant.STOCK_HIDDEN);
  })};

	render() {

		let {visible, onCancel, activeOption} = this.props;
		let {modalShown} = this.state;

		return (
			<FJCommonModal visible={visible}
                     onShown={this._onShown}
                     onHidden={this._onHidden}
										 onCancel={onCancel}
										 width='100%'
										 isStockVideoStyle={true}
										 height='100%'
			>
        <FJStockBox render={() => {
          return (
            <>
              <FJStockVideoHeaderViewContainer/>
              <FJLazy shown={modalShown && activeOption === FJViewConstant.STOCK_VIDEO_VIDEO} render={(shown) => <FJVideoMediasContainer active={shown}/>} />
              <FJLazy shown={modalShown && activeOption === FJViewConstant.STOCK_VIDEO_PHOTO} render={(shown) => <FJPhotoMediasContainer active={shown}/>} />
              <FJLazy shown={modalShown && activeOption === FJViewConstant.STOCK_VIDEO_MUSIC} render={(shown) => <FJMusicMediasContainer active={shown}/>} />
              {
                this.state.tips.map((item) => {
                  return <FJStockTipsView key={item.id}
                                          text={FJLocalStore._(item.type === 'add' ? 'add-stock' : 'remove-stock')}
                                          active={item.active}
                  />
                })
              }
            </>
          );
        }}/>
			</FJCommonModal>
		)
	}

}

const mapStateToProps = function (state) {
	return {
		visible: state.modal.isShowStockVideoModal,
		activeOption: state.stock.activeOption
	}
}

const mapDispatchToProps = function (dispatch) {
	return {

	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJStockVideoModalContainer);